module.exports = __webpack_public_path__ + "img/image6.4c7be1b3.jpg";